<template>
    <div class="comments">
        <h2>{{totalComments}} {{ totalComments === 1 ? 'komentārs' : 'komentāri'}}</h2>

        <comment-form v-if="user && user.id != material.owner_id" :materialId="material.id" class="comment" @commented="getComments({ page: 1 })"></comment-form>

        <comment v-for="comment in comments" :key="comment.id" @commented="getComments({ page: 1 })"
                 :comment="comment" :material="material" class="comment"></comment>

        <div v-if="page < totalPages" class="text-center">
            <button class="button hollow secondary" type="button" @click.prevent="more()">Ielādēt</button>
        </div>
    </div>
</template>

<script>
    import comments from '../api/comments'
    import { mapGetters } from 'vuex'
    import CommentForm from './comments/CommentForm'
    import Comment from './comments/Comment'

    export default {
        props: {
            material: {
                type: Object,
                required: true,
            }
        },

        created() {
            this.getComments();
        },

        data() {
            return {
                comments: [],
                page: 1,
                totalPages: 1,
                totalComments: 0,
            }
        },

        methods: {

            /**
             * Get comments.
             */
            getComments(params) {
                comments.get(this.material.id, params)
                    .then(response => {
                        if (response.data.meta.current_page === 1) {
                            this.comments = response.data.data;
                        } else {
                            this.comments = this.comments.concat(response.data.data);
                        }

                        this.page = response.data.meta.current_page;
                        this.totalPages = response.data.meta.last_page;
                        this.totalComments = response.data.meta.total;
                });
            },

            /**
             * Load more comments based on pagination data.
             */
            more() {
                if (this.page < this.totalPages) {
                    this.getComments({ page: this.page + 1 });
                }
            },

            /**
             * Reset component data.
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            }
        },

        computed: {

            ...mapGetters(['user']),

        },

        watch: {
            material: function (val, oldVal) {
                this.getComments()
            }
        },

        components: { Comment, CommentForm }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .comments {
        background-color: #FFFFFF;
        border: 1px solid $color-iron-gray;
        padding: 25px 50px;

        h2 {
            font-size: px-em(18px);
        }

        .comment + .comment {
            border-top: 1px solid $color-iron-gray;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Comments.vue